<script>
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import FundraiserTeamListGroupItem from '@/components/fundraisers/fundraiser-tabs/fundraiser-team-list-group-item.vue'
import { useTeamPublicStore } from '@/stores/teamPublic.js'
import TwPaginator from '@/components/generic/tw-paginator.vue'
import DonationListGroupItemB from '@/components/donations/public/donation-list-group-item-b.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import fetchItemsMixinWithWatcher from '@/mixins/fetchItemsMixinWithWatcher.js'
import { useDonationsPublicStore } from '@/stores/donationPublic.js'
import TeamCompact from '@/components/teams/public/team-compact.vue'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'

export default {
  name: 'FundraiserTeams',
  components: { TwGridDual, TeamCompact, TwLoadingSpinner, TwCard, TwPaginator, FundraiserTeamListGroupItem, TwListGroup },
  mixins: [fetchItemsMixinWithWatcher],
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    alwaysExpanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemsStoreModule() {
      return useTeamPublicStore('fundraiser_teams_' + this.fundraiser.id)
    },
    filters() {
      return {
        fundraiser_id: this.fundraiser.id,
      }
    }
  },
  mounted() {
    useTeamPublicStore('fundraiser_teams_' + this.fundraiser.id).perPage = 10
    this.fetchItems()
  }
}
</script>

<template>
  <div>
    <tw-loading-spinner v-if="LoadingFetchingItems" />
    <tw-grid-dual v-else-if="!LoadingFetchingItems && items.length > 0">
      <team-compact v-for="team in items" :key="'fundraiser-teams-' + fundraiser.id + '-' + team.id" :team="team" />
    </tw-grid-dual>
    <tw-card v-else class="text-center text-gray-600">
      No teams yet
    </tw-card>
    <tw-paginator v-if="showPaginator" v-model="page" :per-page="perPage" class="flex justify-center mt-10" :total="total" />
  </div>
</template>

<style scoped>

</style>
